import React, { useEffect, useState } from 'react';
import GoogleMapReact from 'google-map-react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { usePosition } from 'use-position';
import {
  setPos, setUserPos, getActivitiesByTypeAndDate, setActiveOa,
} from '../../actions';


import Marker from '../Marker/Marker';

function Map(props) {
  const { latitude, longitude } = usePosition();
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    setUserPos(latitude, longitude);
  }, [latitude, longitude]);
  return (
    <div id="map" className={props.activeOa.seq_cadast !== 0 ? 'active' : ''}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: 'AIzaSyBCM9oPacSqm8A_9dKs1TqSdu09_Bwsz0Q' }}
        defaultCenter={{ lat: 25.42, lng: -49.27 }}
        center={props.lat !== 0 ? { lat: parseFloat(props.lat), lng: parseFloat(props.lng) } : { lat: props.userLat, lng: props.userLng }}
        zoom={props.zoom}
        onGoogleApiLoaded={() => setLoaded(true)}
      >
        {
          loaded && Object.keys(props.oas).map((key) => {
            if (props.oas[key].num_latitu.trim() !== '' || props.oas[key].num_latitu.trim() !== '') {
              const onClickMarker = async (seqCadast) => {
                await props.setPos(parseFloat(props.oas[key].num_latitu), parseFloat(props.oas[key].num_longit), props.oas[key]);
                await props.history.push(`/oa/${seqCadast}`);
                props.getActivitiesByTypeAndDate();
              };

              return (
                <Marker
                  className={`MapMarker ${props.activeOa.seq_cadast === props.oas[key].seq_cadast ? 'active' : ''}`}
                  key={Math.random()}
                  lat={parseFloat(props.oas[key].num_latitu)}
                  lng={parseFloat(props.oas[key].num_longit)}
                  onClick={() => onClickMarker(props.oas[key].seq_cadast)}
                  type={props.oas[key].ide_tipo_oa}
                />
              );
            }
          })
        }
      </GoogleMapReact>
    </div>
  );
}
const mapStateToProps = (store) => ({
  oas: store.oasState.oas,
  activeOa: store.oasState.activeOa,
  lat: store.mapState.lat,
  lng: store.mapState.lng,
  userLat: store.mapState.userLat,
  userLng: store.mapState.userLng,
  zoom: store.mapState.zoom,

});
const mapDispatchToProps = (dispatch) => bindActionCreators({ setPos, getActivitiesByTypeAndDate, setActiveOa }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Map);
